import axios from 'axios';

const apiBearer = axios.create({
  //baseURL: 'http://localhost:2995/',
   baseURL: 'https://wssite.apolar.net/',
  // baseURL: 'https://homologwssite.apolar.net/',
});

export default apiBearer;
